module.exports = __webpack_public_path__ + "img/geod_11.7989f496.jpg";